import { render, staticRenderFns } from "./DataViewerTable.vue?vue&type=template&id=a95b5b42&scoped=true&"
import script from "./DataViewerTable.vue?vue&type=script&lang=js&"
export * from "./DataViewerTable.vue?vue&type=script&lang=js&"
import style0 from "./DataViewerTable.vue?vue&type=style&index=0&id=a95b5b42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95b5b42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataFooter } from 'vuetify/lib/components/VDataIterator';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataFooter,VDataTable})
